import { SavebarRoot, Spacer } from "./Savebar";
import { CancelButton, ConfirmButton, DeleteButton } from "./SavebarActionButtons";

export const Savebar = Object.assign(SavebarRoot, {
  Spacer,
  DeleteButton,
  ConfirmButton,
  CancelButton,
});
